import { useEffect, useState } from 'react';

const themeImages = [
  'Attire.jpg',
  'Beach.jpg',
  'Bohemian.jpg',
  'Bouquet.jpg',
  'Cake.jpg',
  'Classic.jpg',
  'Indoor.jpg',
  'Luxury.jpg',
  'Mandap.jpg',
  'Minimalistic.jpg',
  'Modern.jpg',
  'Outdoor.jpg',
  'Proposal.jpg',
  'Rustic.jpg',
  'Southwestern.jpg',
  'Tropical.jpg'
];

export const getRandomThemeImage = (): string => {
  const randomIndex = Math.floor(Math.random() * themeImages.length);
  return `/themesOption/${themeImages[randomIndex]}`;
};

export const useRandomImage = () => {
  const [imagePath, setImagePath] = useState<string>('');

  useEffect(() => {
    setImagePath(getRandomThemeImage());
  }, []);

  return imagePath;
}; 